import React, { Component } from "react";
import Switch from "react-switch";

export default class SwitchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.value === "true"
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(checked) {
        this.setState({ checked }, this.props.onChange(checked, this.props.id));
    }

    render() {
        return (
                <Switch onChange={this.handleChange} checked={this.state.checked} />
        );
    }
}